import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Menu from "../Menu";

const UpdateSubGroup = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    id: id,
    active: true,
    remark: "",
  });
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const navigate = useNavigate();
  const baseApiUrl = "https://api.dqr-display-tms.bonrix.in/api/GroupOperation/SubUser";

  const token = getCookie("token");
  const userid = getCookie("userid");

  // Fetch SubGroup data on load
  useEffect(() => {
    const fetchSubGroupData = async () => {
      try {
        const response = await axios.post(
          `${baseApiUrl}/Search`,
          {
            id: parseInt(id),
            ispageload: false,
            pagesize: 1,
            currentpageno: 0,
            withoutpagination: false,
            pagedirection: "first",
          },
          {
            headers: {
              "X-Authorization": token,
              UserId: userid,
              "Content-Type": "application/json-patch+json",
            },
          }
        );

        if (response.data && response.data.data) {
          const subgroupData = Array.isArray(response.data.data)
            ? response.data.data[0]
            : response.data.data;

          if (subgroupData) {
            setFormData({
              id: subgroupData.id,
              active: subgroupData.active !== undefined ? subgroupData.active : true,
              remark: subgroupData.remark || "",
            });
          }
        }
      } catch (error) {
        console.error("Error fetching SubGroup data:", error);
        setMessage("Failed to load SubGroup data");
        setMessageType("error");
      } finally {
        setPageLoading(false);
      }
    };

    if (id) {
      fetchSubGroupData();
    }
  }, [id, token, userid]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.remark.trim()) {
      setMessage("Remark is required");
      setMessageType("error");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${baseApiUrl}/Update`,
        {
          id: formData.id,
          active: formData.active,
          remark: formData.remark,
        },
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      // Check if the API response indicates success or failure
      if (response.data && response.data.isresponse && response.data.responsestatus !== "FAIL") {
        setMessage("SubGroup updated successfully!");
        setMessageType("success");
        // Navigate back to SubGroup list after 1.5 seconds
        setTimeout(() => {
          navigate("/group");
        }, 1500);
      } else {
        // Display the error message from API
        setMessage(response.data?.errormsg || "Failed to update SubGroup");
        setMessageType("error");
      }
    } catch (error) {
      console.error("Error updating SubGroup:", error);
      setMessage("Failed to update SubGroup");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/group");
  };

  if (pageLoading) {
    return (
      <>
        <Menu />
        <div className="wrapper">
          <div className="content-wrapper">
            <section className="content">
              <div className="container-fluid text-center p-5">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h1 className="mb-0">Update SubGroup</h1>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-8 offset-md-2">
                  <div className="card">
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        {/* <div className="form-group">
                          <label>SubGroup ID</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.id}
                            disabled
                          />
                        </div> */}

                        <div className="form-group">
                          <label htmlFor="remark">Remark</label>
                          <textarea
                            className="form-control"
                            id="remark"
                            name="remark"
                            value={formData.remark}
                            onChange={handleInputChange}
                            placeholder="Enter remark"
                            rows="4"
                          ></textarea>
                        </div>

                        <div className="form-group">
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="active"
                              name="active"
                              checked={formData.active}
                              onChange={handleInputChange}
                            />
                            <label className="custom-control-label" htmlFor="active">
                              Active
                            </label>
                          </div>
                        </div>

                        <div className="form-group">
                          <button
                            type="submit"
                            className="btn btn-primary mr-2"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                Updating...
                              </>
                            ) : (
                              <>
                                <i className="fas fa-save mr-1"></i>Update SubGroup
                              </>
                            )}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleCancel}
                            disabled={loading}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Message display */}
      {message && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            width: "400px",
            zIndex: "9999",
          }}
        >
          <div
            className={`alert ${
              messageType === "success" ? "alert-success" : "alert-danger"
            } d-flex align-items-center`}
            role="alert"
          >
            <i
              className={`fas ${
                messageType === "success" ? "fa-check-circle" : "fa-exclamation-circle"
              } mr-2`}
            ></i>
            <div>{message}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateSubGroup;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

